module.exports = __webpack_public_path__ + "media/site/images/products/eplaning-flat-screen3-473484a981acbba8241285c6c470a589.png";